import React from 'react';

const RotateIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M3.5 12.1525C3.5 17.0389 7.52944 21 12.5 21C17.4706 21 21.5 17.0389 21.5 12.1525C21.5 7.26622 17.5 3.30508 12.5 3.30508C6.5 3.30508 3.5 8.22034 3.5 8.22034M3.5 8.22034L3.5 3M3.5 8.22034H8.1551" stroke="#363853" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default RotateIcon;